export const GOVGR_PAGINATION = "govgr-pagination";
export const GOVGR_PAGINATION__LABEL = "govgr-pagination__label";
export const GOVGR_PAGINATION__LIST = "govgr-pagination__list";
export const GOVGR_PAGINATION__ITEM = "govgr-pagination__item";
export const GOVGR_PAGINATION__ITEM__INACTIVE =
  "govgr-pagination__item--inactive";
export const GOVGR_LINK = "govgr-link";
export const GOVGR_SVG_ICON = "govgr-svg-icon";
export const GOVGR_ARROW__LEFT = "gov-arrow--left";
export const GOVGR_ARROW__RIGHT = "gov-arrow--right";
export const GOVGR_VISUALLY_HIDDEN = "govgr-visually-hidden";
export const GOVGR_PAGINATION__ITEM__CURRENT =
  "govgr-pagination__item--current";
export const GOVGR_PAGINATION__ITEM__DOTS = "govgr-pagination__item--dots";
